import React from "react";
import { BRAND } from "@/lib/brand";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFAB() {
  return (
    <a
      href={BRAND.whatsappUrl}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-emerald-brand text-white flex items-center justify-center brand-shadow-lg pulse-ring"
      aria-label="Chat on WhatsApp"
      style={{ background: "#25D366" }}
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
